import Fuse from 'fuse.js'
import type { Proc_Procedure } from '../Proc/Proc.Procedure'
import type { Proc_ProcedureWorkflow } from '../Proc/Proc.ProcedureWorkflow'
import type { WF_DisplayProcedureWorkflow } from './WF.DisplayProcedureWorkflow'

export class WF_ProcedureSearcher {
    private procedureFuse: Fuse<Proc_Procedure>
    private procedureWorkflowFuseMap: Map<number, Fuse<Proc_ProcedureWorkflow>> = new Map()

    constructor(private procedures: Proc_Procedure[]) {
        this.procedureFuse = new Fuse(procedures, {
            keys: ['name'],
            threshold: 0.2,
            ignoreLocation: true,
        })

        procedures.forEach((procedure) => {
            this.procedureWorkflowFuseMap.set(
                procedure.id,
                new Fuse(procedure.workflows, {
                    keys: ['name'],
                    threshold: 0.2,
                    ignoreLocation: true,
                })
            )
        })
    }

    public search(searchTerm: string): Proc_Procedure[] {
        if (!searchTerm) {
            return this.procedures
        }

        // Get a list of procedure ids which match the search
        const matchingProcedureIds: number[] = this.procedureFuse.search(searchTerm).map((result) => result.item.id)
        const results: WF_DisplayProcedureWorkflow[] = []

        for (const procedure of this.procedures) {
            // If the procedure matches add the procedure with all the workflow
            if (matchingProcedureIds.includes(procedure.id)) {
                results.push(procedure)
            } else {
                const filteredWorkflows: Array<{
                    id: number
                    name: string
                    type: 'guide' | 'task' | 'training'
                }> = this.procedureWorkflowFuseMap
                    .get(procedure.id)
                    .search(searchTerm)
                    .map((result) => result.item)

                // If any of the workflows match create a procedure workflow with the matching workflows
                // Otherwise we do not want to add the procedure
                if (filteredWorkflows.length > 0) {
                    results.push({
                        ...procedure,
                        workflows: filteredWorkflows,
                    })
                }
            }
        }

        return results
    }
}
